import { create } from "zustand";

interface AskState { open: boolean; seed?: string; account?: string; conversationId?: string; launchId: number; openAsk: (seed?: string, account?: string, conversationId?: string) => void; closeAsk: () => void }
export const useAskStore = create<AskState>((set) => ({
  open: false, seed: undefined, account: undefined, launchId: 0,
  openAsk: (seed, account, conversationId) => set((state) => ({ open: true, seed, account, conversationId, launchId: seed || conversationId ? state.launchId + 1 : state.launchId })),
  closeAsk: () => set({ open: false }),
}));
